import React from 'react';
import { Button } from './ui/Button';
// Hand-drawn brush stroke highlight - sits behind text like a marker highlight
function BrushStrokeHighlight({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 300 24" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-77">
      {/* Main brush stroke with organic, hand-drawn feel */}
      <path d="M8 14C12 11 28 9 45 10C62 11 78 8 95 9C112 10 128 7 145 8C162 9 178 6 195 8C212 10 228 7 245 9C262 11 278 8 292 10" stroke="currentColor" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" opacity="0.85" data-id="element-78" />
      {/* Secondary stroke for texture */}
      <path d="M15 16C35 12 55 14 75 13C95 12 115 15 135 14C155 13 175 16 195 14C215 12 235 15 255 13C275 11 285 14 290 13" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" data-id="element-79" />
      {/* Accent stroke for more organic feel */}
      <path d="M5 12C25 15 45 11 65 13C85 15 105 10 125 12C145 14 165 9 185 11C205 13 225 10 245 12C265 14 280 11 295 13" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" opacity="0.4" data-id="element-80" />
    </svg>;
}
export function Hero() {
  return <section className="relative w-full py-24 md:py-32 lg:py-40 px-4 overflow-hidden" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center" data-id="element-82">
        <div className="space-y-2 md:space-y-4 mb-8 md:mb-12" data-id="element-83">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#1a1a1a] tracking-tight leading-tight" data-id="element-84">
            <span className="block" data-id="element-85">Celebrate.</span>
            <span className="block text-[#4A6FA5]" data-id="element-86">Honor.</span>
            <span className="relative inline-block" data-id="element-87">
              {/* Brush stroke highlight behind the text */}
              <BrushStrokeHighlight className="absolute left-[-5%] right-[-5%] bottom-[5%] md:bottom-[8%] w-[110%] h-[35%] md:h-[30%] text-[#4A6FA5] -z-10" data-id="element-88" />
              <span className="relative" data-id="element-89">Support.</span>
            </span>
          </h1>
        </div>

        <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-90">
          Recognizing and inspiring great fathers and father-figures in our
          community through essays written by their children.
        </p>

        <div className="flex justify-center" data-id="element-91">
          <Button href="#partner" className="text-lg px-8 py-4" data-id="element-92">
            Partner With Us
          </Button>
        </div>
      </div>
    </section>;
}